const TRANSLATIONS = {
    "concept" : {
        "fr": "Concept",
        "en": "Concept"
    },
    "individual" : {
        "fr": "Individu",
        "en": "Individual"
    },
    "boolean" : {
        "true": {
            "en": "True",
            "fr": "Vrai",
            "de": "Wahr",
            "it": "Vero",
            "es": "Verdadero",
            "nl": "Waar",
            "pt": "Verdadeiro",
        },
        "false": {
            "en": "False",
            "fr": "Faux",
            "de": "Falsch",
            "it": "Falso",
            "es": "Falso",
            "nl": "Onwaar",
            "pt": "Falso",
        }
    },
    "method" : {
        "LEXICAL_MATCHING" : {
            "en": "Lexical matching",
            "fr": "Appariement lexical"
        },
        "STRING_BASED_SIMILARITY" : {
            "en": "String-based similarity",
            "fr": "Similarité basée sur les chaînes"
        },
        "STRUCTURAL_MATCHING" : {
            "en" : "Structural matching",
            "fr" : "Appariement structurel"
        },
        "INSTANCE_BASED_MATCHING" : {
            "en" : "Instance-based matching",
            "fr" : "Appariement basé sur les instances"
        },
        "SEMANTIC_MATCHING" : {
            "en" : "Semantic matching",
            "fr" : "Appariement sémantique"
        },
        "MACHINE_LEARNING_BASED_MATCHING" : {
            "en" : "Machine learning-based matching",
            "fr" : "Appariement basé sur l'apprentissage automatique"
        },
        "DEEP_LEARNING_BASED_MATCHING" : {
            "en" : "Deep learning-based matching",
            "fr" : "Appariement basé sur l'apprentissage profond"
        },
        "RULE_BASED_MATCHING" : {
            "en" : "Rule-based matching",
            "fr" : "Appariement basé sur des règles"
        },
        "ONTOLOGY_ALIGNMENT_TOOLS" : {
            "en" : "Ontology alignment tools",
            "fr" : "Outils d'alignement d'ontologies"
        },
        "HYBRID_MATCHING" : {
            "en" : "Hybrid matching",
            "fr" : "Appariement hybride"
        }
    },
    "validity" : {
        "VALIDATED" : {
            "en" : "Validated",
            "fr" : "Validé"
        },
        "PROPOSED" : {
            "en" : "Proposed",
            "fr" : "Proposé"
        },
        "NOT_EVALUATED" : {
            "en" : "Not Evaluated",
            "fr" : "Non évalué"
        },
        "INVALID" : {
            "en" : "Invalid",
            "fr" : "Invalidé"
        },
        "UNDER_REVIEW" : {
            "en" : "Under Review",
            "fr" : "En cours d'examen"
        },
        "DEPRECATED" : {
            "en" : "Deprecated",
            "fr" : "Obsolète"
        },
        "PARTIALLY_CORRECT" : {
            "en" : "Partially Correct",
            "fr" : "Partiellement correct"
        }
    }
};

export default TRANSLATIONS;
